export const toolbarStyles = {
  defaultProps: {
    variant: 'secondary',
    size: 'md',
  },
}
